import { SET_SALE, SET_SALES, SET_SALES_LOADING, SET_SALES_ERROR } from "../../actions/saleAction";

var initialState = {
  datas: [],
  selected: null,
  loading: false,
  error: null,
};

const saleReducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case SET_SALES:
      return {
        ...state,
        datas: action.data,
      };
    case SET_SALE:
      return {
        ...state,
        selected: action.data,
      };

    case SET_SALES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_SALES_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    default:
      return state;
  }
};

export default saleReducer;
